import {Badge, Space} from "antd";

export const dataTab = {
    "query": {
        "id": "USERS_UI_V",
        "source": "USERS_UI_V",
        "fields": [
            {   "column": "filial"/*, "format": "text", "type": "text"*/ },
            {   "column": "filial_name"/*, "format": "text", "type": "text"*/ },
            {   "column": "id"/*, "format": "number", "type": "number"*/ },
            {   "column": "fio"/*, "format": "text", "type": "text"*/ },
            {   "column": "tin"/*, "format": "text", "type": "text"*/ },
            {   "column": "pinfl"/*, "format": "text", "type": "text"*/ },
            {   "column": "login"/*, "format": "text", "type": "text"*/ },
            {   "column": "dateexpire"/*, "format": "date"*/},
            {   "column": "dateopen"/*, "format": "date"*/ },
            {   "column": "cnttries"/*, "format": "number", "type": "number"*/ },
            {   "column": "deptlevel"/*, "format": "number", "type": "number"*/ },
            {   "column": "mobilenumber"/*, "format": "text", "type": "text"*/ },
            {   "column": "phonenumber"/*, "format": "text", "type": "text" */},
            {   "column": "staff"/*, "format": "text", "type": "text"*/ },
            {   "column": "staff_name"/*, "format": "text", "type": "text"*/ },
            {   "column": "struct"/*, "format": "text", "type": "text"*/ },
            {   "column": "struct_name"/*, "format": "text", "type": "text"*/ },
            {   "column": "state"/*, "format": "number", "type": "number"*/ },
            {   "column": "state_name"/*, "format": "text", "type": "text"*/ },
            {   "column": "reason"/*, "format": "text", "type": "text"*/ },
            {   "column": "created_by"/*, "format": "number", "type": "number" */},
            {   "column": "created_date"/*, "format": "date" */},
            {   "column": "created_by_name"/*, "format": "text", "type": "text"*/ },
            {   "column": "modified_by"/*, "format": "number", "type": "number"*/ },
            {   "column": "modified_date"/*, "format": "date"*/ },
            {   "column": "modified_by_name"/*, "format": "text", "type": "text"*/ },
        ]
    }
}

export const dataFilter = [
    { "column": "id", "label": "ИД", "operator": "=", "datatype":"number" },
    { "column": "fio", "label": "Номи", "operator": "text", "datatype":"text"},
    { "column": "login", "label": "Логин", "operator": "text", "datatype":"text"},
    { "column": "struct", "label": "Тузилма", "operator": "=", "datatype":"text","type":"S","typeRef":"STRUCTURE"},
    { "column": "staff", "label": "Лавозим", "operator": "in", "datatype":"text","type":"M","typeRef":"STAFF"},
    { "column": "filial", "label": "Филиал", "operator": "in", "datatype":"text","type":"M","typeRef":"FILIAL"},
    { "column": "state", "label": "Холат", "operator": "in", "datatype":"number","type":"M","typeRef":"DOCSTATE","paramRef":"EMPLOYEE"},
    { "column": "role", "label": "Рол", "operator": "exists", "datatype":"number", "type":"W", "table":"access_role", "tableId":"USERS_UI_V.id", "tableIdColumn":"emp", "typeRef": "ROLE" },
]

export const columns = [
    {
        title: 'ИД',
        dataIndex: 'id',
        fixed: 'left',
        width: 100,
        defaultSortOrder: 'descend',
        sorter: (a, b) => a.id - b.id,
    },
    {
        title: 'Ф.И.Ш.',
        dataIndex: 'fio',
        fixed: 'left',
        width: 200,
        //sorter: (a, b) => a.fio.length - b.fio.length,
        sorter: (a, b) => {
            const nameA = a.fio || '';
            const nameB = b.fio || '';
            return nameA.localeCompare(nameB);
        },

        //sortOrder: sortedInfo.columnKey === 'name' ? sortedInfo.order : null,
        ellipsis: true,
    },
    {
        title: 'ИНН',
        dataIndex: 'tin',
        width: 100,
        sorter: (a, b) => a.tin.length - b.tin.length,
    },
    {
        title: 'ПИНФЛ',
        dataIndex: 'pinfl',
        width: 100,
        sorter: (a, b) => a.pinfl.length - b.pinfl.length,
    },
    {
        title: 'Лавозим',
        dataIndex: 'staff_name',
        width: 100,
    },
    {
        title: 'Логин',
        dataIndex: 'login',
        width: 100,
        sorter: (a, b) => {
            const nameA = a.login || '';
            const nameB = b.login || '';
            return nameA.localeCompare(nameB);
        },
    },
    /*{
        title: 'Телефон ракам',
        ellipsis: true,
        dataIndex: 'phoneNumber',
        width: 100,
    },
    {
        title: 'Мобил тел. раками',
        ellipsis: true,
        dataIndex: 'mobileNumber',
        width: 100,
    },*/
    {
        title: 'Очилган сана',
        dataIndex: 'dateopen',
        ellipsis: true,
        width: 100,
        sorter: (a, b) => a.dateOpen - b.dateOpen,
    },
    {
        title: 'Фойдаланиш санаси',
        ellipsis: true,
        dataIndex: 'dateexpire',
        width: 100,
    },
    {
        title: 'Кириш уриниши',
        ellipsis: true,
        dataIndex: 'cnttries',
        width: 100,
    },
    {
        title: 'Холат',
        dataIndex: 'state_name',
        fixed: 'right',
        width: 100,
        sorter: (a, b) => {
            const nameA = a.state_name || '';
            const nameB = b.state_name || '';
            return nameA.localeCompare(nameB);
        },
        render: (text, record) => {
            return (
                <Space size="middle">
                    {
                          record.state === 2 ? <Badge status="success" text={text} />
                        : record.state === 3 ? <Badge status="volcano" text={text} />
                        : <Badge status="default" text={text} />
                    }
                </Space>
            )
        },
    },
];


export const dataFilialTab = {
    "query": {
        "id": "FILIAL_REF",
        "source": "FILIAL_REF",
        "fields": [
            {   "column": "code"/*, "format": "text", "type": "text"*/ },
            {   "column": "name"/*, "format": "text", "type": "text"*/ },
            {   "column": "territory"/*, "format": "text", "type": "text"*/ },
            {   "column": "region"/*, "format": "text", "type": "text"*/ },
            {   "column": "created_by"/*, "format": "number", "type": "number"*/ },
            {   "column": "created_date", "format": "date", "type": "char" },
            {   "column": "modified_by"/*, "format": "number", "type": "number"*/ },
            {   "column": "modified_date", "format": "date", "type": "char" }
        ]
    }
}

export const dataFilial = [
    {
        "code": "000",
        "name": "Марказий аппарат"
    },{
        "code": "573",
        "name": "Тошкент шахар"
    },{
        "code": "433",
        "name": "Андижон вилояти"
    },
];
export const dataStruct = [
    {
        "code": "0",
        "name": "Молия"
    },{
        "code": "1",
        "name": "Бухгалтерия"
    }
];
export const dataPosition = [
    {
        "code": "01000",
        "name": "Молиячи"
    },{
        "code": "01010",
        "name": "Бухгалтер"
    },{
        "code": "01030",
        "name": "Рахбар"
    }
]

